import React, { lazy, Suspense } from 'react';

const LazyDeveloperRegister = lazy(() => import('./DeveloperRegister'));

const DeveloperRegister = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode },
) => (
  <Suspense fallback={null}>
    <LazyDeveloperRegister {...props} />
  </Suspense>
);

export default DeveloperRegister;
